module.exports = __webpack_public_path__ + "static/media/d.3a8b2b3e.JPG";